import * as actions from './actions';
import * as types from './types';
import deviceReducer from './reducers';

export default deviceReducer;

export {
  actions,
  types,
};
